import { Swiper } from 'swiper/core';
import type { SwiperOptions } from 'swiper/types';
import { Pagination } from 'swiper/modules';
import { onReady } from './util/onReady';

function imageGrid() {
    const containers = document.querySelectorAll<HTMLElement>('[data-swiper-container]');
    containers.forEach((container) => {
        const isMobile = window.screen.width < 768;
        const itemsPerPage = isMobile ? 4 : 6;

        // Split the images into groups that can be slided / toggled
        const slides: Array<Array<HTMLElement>> = [];
        let slideItems: Array<HTMLElement> = [];

        let i = 0;
        while (container.firstElementChild) {
            if (i % itemsPerPage === 0) {
                slideItems = [];
                slides.push(slideItems);
            }

            const element = container.firstElementChild as HTMLElement;
            container.removeChild(element);
            slideItems.push(element);
            i++;
        }

        const wrapper = getDivWithClass('swiper-wrapper');
        container.appendChild(wrapper);
        slides.forEach((group) => {
            const slide = getDivWithClass('swiper-slide');
            wrapper.appendChild(slide);

            group.forEach((element) => {
                slide.appendChild(element);
            });
        });

        // Add pagination container
        container.appendChild(getDivWithClass('swiper-pagination'));
        container.classList.add('swiper-container');

        const swiperParams: SwiperOptions = {
            modules: [Pagination],
            slidesPerView: 1,
            watchOverflow: true,
            pagination: { el: '.swiper-pagination', clickable: true },
        };

        new Swiper(container, swiperParams);
    });
}

function getDivWithClass(className: string) {
    const element = document.createElement('div');
    element.className = className;
    return element;
}

onReady(() => {
    imageGrid();
});
